module.exports = __webpack_public_path__ + "img/hvFormatoUnico.dc58ecdb.png";